import TagsAnalyticCell from 'routes/NewMemberAnalytics/components/TagsAnalyticCell/TagsAnalyticCell';

export default TagsAnalyticCell;
